import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { HelperTranslationControllerService, LanguageCode } from '../helpers/helper-translation-controller.service';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private lastKey: string = '';
  private lastLang?: LanguageCode;
  private lastValue: string = '';
  private subscription?: Subscription;

  constructor(
    private translationService: HelperTranslationControllerService,
    private cdr: ChangeDetectorRef
  ) {
    this.subscription = this.translationService.currentLang$.subscribe(() => {
      if (!this.lastKey) return;
      this.lastValue = this.lastLang !== undefined
        ? this.translationService.translate(this.lastKey, this.lastLang)
        : this.translationService.translate(this.lastKey);
      this.cdr.markForCheck();
    });
  }

  transform(key: string, langOverride?: LanguageCode): string {
    if (!key) return '';
    if (key !== this.lastKey || langOverride !== this.lastLang) {
      this.lastKey = key;
      this.lastLang = langOverride;
      this.lastValue = langOverride !== undefined
        ? this.translationService.translate(key, langOverride)
        : this.translationService.translate(key);
    }
    return this.lastValue;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
